/**
 * Steam news for the title a Drop promotes.
 *
 * Cached for two hours to match the backend — Steam announcements do not move
 * faster than that, and refetching on every mount would spend requests to
 * re-render the same four posts.
 */
import { useQuery } from "@tanstack/react-query";
import { DropsApi, DropGameNewsResponse } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropGameNews(slug?: string) {
    return useQuery<DropGameNewsResponse | null>({
        queryKey: ["drop-game-news", slug],
        queryFn: async () => {
            if (!slug) return null;
            return new DropsApi(getConfig()).getDropsSlugSlugContentGameNews({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 2 * 60 * 60 * 1000,
    });
}
